import { defineComponent as o, openBlock as r, createBlock as n, unref as l, mergeProps as c, withCtx as m, createElementVNode as p } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const d = /* @__PURE__ */ o({
  name: "IconScratches",
  __name: "IconScratches",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (i, e) => (r(), n(l(s), c(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        p("path", { d: "M12.53 3.47a.75.75 0 1 0-1.06 1.06l8 8a.75.75 0 1 0 1.06-1.06l-8-8m-8.06 1a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06m5.25 5.25a.75.75 0 0 1 1.06 0l8.75 8.75a.75.75 0 1 1-1.06 1.06l-8.75-8.75a.75.75 0 0 1 0-1.06m-6.25 1.75a.75.75 0 0 1 1.06 0l8 8a.75.75 0 1 1-1.06 1.06l-8-8a.75.75 0 0 1 0-1.06" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
